import $ from "jquery";

export function setFocusStates() {
    let clicked = false;

    $("body")
        .on("mousedown", () => (clicked = true))
        .on("touchstart", () => (clicked = true))
        .on("keydown", () => {
            clicked = false;
        })
        .on("focusin", (e) => (clicked ? $(e.target).removeClass("focus-state") : $(e.target).addClass("focus-state")));
}

$(window).on("load", () => {
    $("body").removeClass("preload");
    setFocusStates();
});
